import AIconButton from '@ahamove/web-components/lib/AIconButton';
import Image from 'next/legacy/image';
import React, { useEffect, useState } from 'react';

export default function ButtonScrollTop() {
  const [visible, setVisible] = useState(false);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const toggleVisibility = () => {
        if (window.scrollY > window.innerHeight / 2) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      };

      window.addEventListener('scroll', toggleVisibility);

      return () => window.removeEventListener('scroll', toggleVisibility);
    }
  }, []);

  if (!visible) return <React.Fragment />;

  return (
    <AIconButton
      rounded
      sx={(theme) => ({
        boxShadow: theme.shadows[2],
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 50,
      })}
      onClick={scrollToTop}
      className="fixed bottom-5 right-5 z-50"
      data-test-id="scrollTopBtn"
    >
      <div className="relative h-5 w-4 bg-transparent">
        <Image src="/static/icons/ArrowNarrowUp.svg" layout="fill" alt="" />
      </div>
    </AIconButton>
  );
}
